import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bba11aa6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "verification-result"
};
const _hoisted_2 = {
  class: "result-content"
};
const _hoisted_3 = {
  class: "main-title"
};
const _hoisted_4 = {
  class: "main-text"
};
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { MainButton } from '@/components';
export default /*#__PURE__*/_defineComponent({
  __name: 'CancellationResult',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const resultTitle = ref('');
    const resultText = ref('');
    const closePage = () => {
      return false;
    };
    onMounted(() => {
      const {
        res = false
      } = route.query;
      resultTitle.value = res ? '注销成功' : '注销失败';
      resultText.value = res ? '您的账户信息已注销' : '注销失败，请重新再试';
    });
    return (_ctx, _cache) => {
      const _component_van_count_down = _resolveComponent("van-count-down");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(resultTitle.value), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(resultText.value), 1), _createVNode(_unref(MainButton), {
        onClick: closePage
      }, {
        default: _withCtx(() => [_createTextVNode(" 关闭 "), _createVNode(_component_van_count_down, {
          class: "cancellation-count-down",
          time: 5 * 1000,
          format: "(ss s)",
          onFinish: closePage
        })]),
        _: 1
      })])]);
    };
  }
});